var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCircle = function SvgCircle(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 2.9c-5.02 0-9.1 4.08-9.1 9.1s4.08 9.1 9.1 9.1 9.1-4.08 9.1-9.1-4.08-9.1-9.1-9.1m0 17c-4.36 0-7.9-3.54-7.9-7.9S7.64 4.1 12 4.1s7.9 3.54 7.9 7.9-3.54 7.9-7.9 7.9"
  })));
};
export { SvgCircle as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M12 2.9c-5.02 0-9.1 4.08-9.1 9.1s4.08 9.1 9.1 9.1 9.1-4.08 9.1-9.1-4.08-9.1-9.1-9.1m0 17c-4.36 0-7.9-3.54-7.9-7.9S7.64 4.1 12 4.1s7.9 3.54 7.9 7.9-3.54 7.9-7.9 7.9'/%3e%3c/svg%3e";